export default __webpack_public_path__ + "static/media/cigna-glyph.bd45e95d.png";